import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIsLinkDataStepVisited = new ReduxAsyncAction<
  'UPDATE_IS_LINK_DATA_STEP_VISITED',
  boolean,
  { isLinkDataStepVisited: boolean }
>('UPDATE_IS_LINK_DATA_STEP_VISITED');

UpdateIsLinkDataStepVisited.registerRequest(async (isLinkDataStepVisited: boolean) => {
  return { isLinkDataStepVisited };
});

export const UPDATE_IS_LINK_DATA_STEP_VISITED = UpdateIsLinkDataStepVisited.actionNamespaceConstants;
export const updateIsLinkDataStepVisited = UpdateIsLinkDataStepVisited.request;

export type UpdateIsLinkDataStepVisitedResponseAction = Action<typeof UPDATE_IS_LINK_DATA_STEP_VISITED.response> & {
  data: { isLinkDataStepVisited: boolean };
};
